import { type UUID } from '~/types/common';

import { type CostCentersAdminQueryParams } from './useQueryCostCentersAdmin';

/**
 * Query key factory for cost center-related queries.
 */
export const queryKeysCostCenter = {
  base: () => 'costCenter' as const,
  getAllAdmin: (queryParams: CostCentersAdminQueryParams) =>
    [queryKeysCostCenter.base(), 'list', 'admin', queryParams] as const,
  getBulkAdmin: (ids: UUID[]) =>
    [queryKeysCostCenter.base(), 'bulkAdmin', { ids }] as const,
} as const;
